import { useIdle } from "application/contexts/idle/IdleContext";
import React, { memo, useCallback, useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Store } from "../../../../domains/catalog/aggregates/Store";
import Toolbar from "areas/_catalog/components/toolbar/Toolbar";
import { ListaCategorias } from "../listaCategorias/ListaCategorias";
import { ItemStore } from "./Components/itemStore/ItemStore";
import "./StoresListPage.css";
import { useCatalogStore } from "application/contexts/catalog/CatalogStore";

export const StoresListPage = memo(() => {
  const [filtroStore, setfiltroStore] = useState<string>("");
  const { path } = useRouteMatch();
  const { catalog } = useCatalogStore();
  const history = useHistory();
  const { handleActiveIdleTimer } = useIdle();


  const [stores, setstores] = useState<Store[]>();

  useEffect(() => {
    handleActiveIdleTimer();
  }, [handleActiveIdleTimer])
  

  const getStore = useCallback(() => {
    if (catalog?.stores) {
      setstores(catalog?.stores);
    }
  }, [catalog])

  const obterStores = useCallback(() => {
    getStore();
    return () => { };
  }, [getStore]);

  useEffect(() => {
    obterStores();
  }, [obterStores]);

  useEffect(() => {
    if (catalog) {
      setfiltroStore("all");
    }
  }, [catalog]);

  const onClickStore = useCallback(
    (index: number) => {
      history.push(path + "/store/" + index);
    },
    [history, path]
  );

  return (
    <div className="container-store">
      <Toolbar
        title={catalog?.name ?? ''}
      ></Toolbar>
      {!filtroStore && catalog ? (
        <>
          <ListaCategorias
            catalog={catalog}
            onClickCategoria={(id) => {
              setfiltroStore(id);
            }}
            onClickTodos={() => setfiltroStore("all")}
          />
        </>
      ) :
        (
          <>
            <div className="container-item-store">
            {stores?.sort((a, b) => a.order - b.order).filter(
                (store) =>
                  store.tags.findIndex((tag) => tag.id === filtroStore) !== -1 || filtroStore === "all"
              ).map((store, index) => (
                <>
                  <ItemStore
                    isClosed={store.isClosed}
                    key={store.id}
                    nome={store.name}
                    imagemUrl={store.thumbnailUrl}
                    id={store.id}
                    onClick={() => onClickStore(index)} />
                </>
              ))}
            </div>
          </>
        )}
    </div>
  );
});
